module.exports = __webpack_public_path__ + "static/media/17.72c0d066.jpeg";